import { GenerateTokenAPI } from "./GenerateTokenAPI";


export const getNewToken = async () => {
    try {
        
        const tokenObj = await GenerateTokenAPI();
        // console.log("error in generateToken", tokenObj)
        if (tokenObj && tokenObj?.data) {
            try {
                localStorage.setItem("token", JSON.stringify({token: tokenObj?.data?.token, validUpTo: (new Date().getTime()) + tokenObj?.data?.expiresInSeconds * 1000 }
                ));
                // console.log("new token", tokenObj?.data?.token)
                return tokenObj?.data?.token;
            } catch (error) {
                console.log("error in generateToken ")
            }
        }
    } catch (error) {
        console.log("error in generateToken asyncstorage function ");
    }
}

export async function getToken() {
    //AsyncStorage.removeItem("token");
    try {
        const tokenString = localStorage.getItem("token");
        if (tokenString) {
            const parsedToken = JSON.parse(tokenString);
            const token = parsedToken.token;
            const validUpTo = parsedToken.validUpTo;

            // console.log("Time Difference:", Math.floor((validUpTo - new Date().getTime()) / 1000))
            if (Math.floor(validUpTo - new Date().getTime()) > 10) {
                console.log("old token", token);
                return token;
            } else {
                return await getNewToken();
            }
        } else {
            return await getNewToken();
        }
    } catch (error) {
        console.error(error)
    }
}

